import styled, { keyframes } from "styled-components";

import { SrOnly } from "../../../foundations/srOnly";

// 셀 2.25rem(36px) / fill(CELL-0.25rem)=2rem(32px). c6 IconButton md 발자국과 비슷하게(사용자 결정).
export const CELL = "2.25rem";
// Year selection view: 4열. 한 pane 폭(CELL*7)에 4열이 맞음. 높이는 day 셀과 같은 밀도.
export const YEAR_BOX_HEIGHT = "2.25rem";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

// 스크린 리더 전용(sr-only) 라이브 리전 — 공유 파운데이션(foundations/srOnly)으로 이전.
export const LiveRegion = SrOnly;

// 뷰 전환 시 새 뷰가 mount되며 fade-in(+살짝 아래→제자리). key로 remount되어 재생된다.
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ViewFade = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  animation: ${fadeIn} 160ms ease;

  /* 장식 모션이므로 reduced-motion에서 제거(§5-C). */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Panes = styled.div`
  display: flex;
  gap: 1.25rem;
`;

export const Pane = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: calc(${CELL} * 7);
`;

// 요일+그리드를 담는 recessed 패널 — 흰 팝업(surface) 위에서 캘린더 영역을 구분한다(§3).
export const GridSurface = styled.div`
  background: ${({ theme }) => theme.color.bg.surfaceSunken};
  border-radius: ${({ theme }) => theme.shape.radius.surface};
  padding: 0.375rem;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
`;

// dual pane 헤더: [nav][라벨(중앙)][nav] 3열로 좌우 나브를 바깥쪽에 배치.
export const PaneHeader = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
`;

export const NavSlot = styled.div<{ $align?: "start" | "end" }>`
  display: flex;
  justify-content: ${({ $align }) => ($align === "end" ? "flex-end" : "flex-start")};
  min-width: 2rem;
`;

// 단일 모드: 이전/다음 월 화살표 묶음(우측 정렬).
export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.125rem;
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, ${CELL});
`;

export const WeekdayCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  font-size: ${({ theme }) => theme.typography.size.caption};
  color: ${({ theme }) => theme.color.text.subtle};
`;

// 월 이동 방향별 slide-in. +1(다음)=오른쪽에서, -1(이전)=왼쪽에서 들어온다.
const slideFromRight = keyframes`
  from { opacity: 0; transform: translateX(8px); }
  to { opacity: 1; transform: translateX(0); }
`;
const slideFromLeft = keyframes`
  from { opacity: 0; transform: translateX(-8px); }
  to { opacity: 1; transform: translateX(0); }
`;

export const Grid = styled.div<{ $dir: 1 | -1 }>`
  display: flex;
  flex-direction: column;
  animation: ${({ $dir }) => ($dir === 1 ? slideFromRight : slideFromLeft)} 160ms ease;

  /* 장식 모션이므로 reduced-motion에서 제거(§5-C). */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Week = styled.div`
  display: grid;
  grid-template-columns: repeat(7, ${CELL});
`;
